import { normalizeQuickMessageShortcut } from "./quickMessages.mjs";

const STATUS_LABELS = {
  building: "Building",
  ready: "Ready",
  partial: "Partial",
  failed: "Failed",
  not_enough_signal: "Not enough signal",
};

const STATUS_TONES = {
  building: "progress",
  ready: "success",
  partial: "warning",
  failed: "danger",
  not_enough_signal: "muted",
};

export function getQuickMessageDiscoveryStatusLabel(status = "") {
  return STATUS_LABELS[String(status || "").trim()] || "Unknown";
}

export function getQuickMessageDiscoveryStatusTone(status = "") {
  return STATUS_TONES[String(status || "").trim()] || "muted";
}

export function formatDiscoveryConfidence(value) {
  const numeric = Number(value);
  if (!Number.isFinite(numeric)) return "0%";
  return `${Math.round(Math.max(0, Math.min(1, numeric)) * 100)}%`;
}

export function buildDiscoveryLaunchPayload(values = {}) {
  return {
    clinic_id: String(values.clinicId ?? "").trim(),
    period_start: String(values.periodStart ?? "").trim(),
    period_end: String(values.periodEnd ?? "").trim(),
  };
}

export function buildDiscoveryCreatePayload(values = {}) {
  return {
    display_name: String(values.displayName ?? "").trim(),
    shortcut: normalizeQuickMessageShortcut(values.shortcut),
    template_body: String(values.templateBody ?? "").trim(),
  };
}

export function buildDiscoveryRunSummary(run = {}) {
  const threads = Number(run.source_thread_count ?? 0);
  const messages = Number(run.source_conversation_count ?? 0);
  const suggestions = Number(run.suggestion_count ?? 0);
  return `${threads} threads · ${messages} messages · ${suggestions} suggestions`;
}

export function isDiscoveryRunActive(status = "") {
  return String(status || "").trim() === "building";
}
